module.exports = __webpack_public_path__ + "img/22.bbe006b4.jpg";